import React from "react";
import { CheckoutFormData, OrderTotals } from "../types";
import { convertCentsToCurrency } from "../utils";
import { SHIPPING_CHARGE } from "../constants";

const OrderTotalsContainer: React.FC<{
  orderTotals: OrderTotals;
  couponData: CheckoutFormData["couponData"];
}> = ({ orderTotals, couponData }) => {
  return (
    <>
      <span className="block h-px f-full bg-gray-200 mb-2 mt-2" />
      <div className="flex items-center justify-between">
        <div>
          <h6>Order subtotal</h6>
        </div>
        <div>
          <span>${convertCentsToCurrency(orderTotals.orderSubtotal)}</span>
        </div>
      </div>
      <div
        className={`flex items-center justify-between${
          orderTotals.bulkDiscount > 0 ? " text-green-600" : ""
        }`}
      >
        <div>
          <h6>Bulk discount</h6>
        </div>
        <div>
          <span>
            {orderTotals.bulkDiscount > 0
              ? `($${convertCentsToCurrency(orderTotals.bulkDiscount)})`
              : "$0.00"}
          </span>
        </div>
      </div>
      {couponData && (
        <div className="flex items-center justify-between text-green-600">
          <div>
            <h6>
              Coupon <strong>{couponData.code}</strong>
            </h6>
          </div>
          <div>
            <span>(${convertCentsToCurrency(couponData.discount)})</span>
          </div>
        </div>
      )}
      {orderTotals.shippingCharge > 0 && (
        <div className="flex items-center justify-between">
          <div>
            <h6>Shipping</h6>
          </div>
          <div>
            <span>${convertCentsToCurrency(SHIPPING_CHARGE)}</span>
          </div>
        </div>
      )}
      <div className="flex items-center justify-between text-lg">
        <div>
          <h6>Order total</h6>
        </div>
        <div>
          <span>${convertCentsToCurrency(orderTotals.orderTotal)}</span>
        </div>
      </div>
    </>
  );
};

export default OrderTotalsContainer;
